import { z } from "zod/v4";

import { ExperienceProductVariantDtoSchema } from "../../../../../../dtos/experience-products";

export const PluginProductVariantSchema_2023_08_20 =
  ExperienceProductVariantDtoSchema.omit({
    title: true,
  });
export type PluginProductVariantType_2023_08_20 = z.infer<
  typeof PluginProductVariantSchema_2023_08_20
>;
